import { InternSet } from "internmap";
export default function union() {
    var others = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        others[_i] = arguments[_i];
    }
    var set = new InternSet();
    for (var _a = 0, others_1 = others; _a < others_1.length; _a++) {
        var other = others_1[_a];
        for (var _b = 0, other_1 = other; _b < other_1.length; _b++) {
            var o = other_1[_b];
            set.add(o);
        }
    }
    return set;
}
